import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.bg = this.el.querySelector('.o-archives_background');
        this.container = this.el.querySelector('.o-archives_container');
        this.tags = this.el.querySelectorAll('.c-tag');
        this.items = this.el.querySelectorAll('.o-archives_list_item');

        document.querySelectorAll('.archivesOpen').forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.open();
            });
        });

        this.events = {
            click: {
                close: 'close',
                filter: 'filter'
            }
        }
    }

    open() {
        this.call('stop', 'Scroll');
        this.el.classList.add('-visible');
        gsap.fromTo(
            this.bg,
            { autoAlpha: 0 },
            { autoAlpha: 1, duration: 0.2, ease: "none" }
        );
        gsap.fromTo(
            this.container,
            { y: '80vh', x: '30vw', rotate: 15, transformOrigin: 'top left' },
            { y: '0', x: '0', rotate: 0, transformOrigin: 'top left', duration: 1, ease: "expo.out" }
        );
    }

    close() {
        this.call('start', 'Scroll');
        gsap.to(this.el, { autoAlpha: 0, duration: 0.2, ease: "none" });
        gsap.to(this.container, { y: '105vh', duration: 1, ease: "expo.out", onComplete: () => {
            this.el.scrollTop = 0;
            this.el.classList.remove('-visible');
            gsap.set(this.el, { autoAlpha: 1 });
        } });
    }


    filter(e) {
        let taxo = e.currentTarget.getAttribute('data-taxo');

        if (e.currentTarget.classList.contains('-active')) {
            e.currentTarget.classList.remove('-active');
        } else {
            this.tags.forEach((item) => {
                item.classList.remove('-active');
            });
            e.currentTarget.classList.add('-active');
        }

        this.items.forEach((item) => {
            if (e.currentTarget.classList.contains('-active')) {
                let itemsTaxos = item.getAttribute('data-taxos') ? item.getAttribute('data-taxos').split(',') : [];

                if (itemsTaxos.indexOf(taxo) == -1) {
                    item.classList.add('-hidden');
                } else {
                    if (item.classList.contains('-hidden')) {
                        item.classList.remove('-hidden');
                    }
                }
            } else {
                item.classList.remove('-hidden');
            }
        });
    }
}
